class VippsMobilePayController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'configurationOptions'
		'shops'

	integrationId: 'vipps_mobile_pay'

	initialize: ->
		@ensureObjectsInConfiguration(@configuration, ['shops'])

		# Remove deleted shops
		for shopId of @configuration.shops
			if !_.find(@shops, {id: shopId})?
				delete @configuration.shops[shopId]

	save: ->
		super(@configuration).then (response) =>
			@configuration = response.data

	afterDisconnect: ->
		@configuration = {}
